import { render, staticRenderFns } from "./DemJobs.vue?vue&type=template&id=535ab6c2&lang=pug"
import script from "./DemJobs.vue?vue&type=script&lang=js"
export * from "./DemJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports